/**
 * Fetch with timeout.
 *
 * @function
 * @param {string} uri - The API URL.
 * @param {object} options - Options object.
 * @param {number} time - Number in milliseconds until abort.
 */
const fetchWithTimeout = (uri, options = {}, time = 5000) => {
	const controller = new AbortController();
	const config = { ...options, signal: controller.signal };

	setTimeout(() => {
		controller.abort();
	}, time);

	return fetch(uri, config)
		.then((response) => {
			if (!response.ok) {
				throw new Error(`${response.status}: ${response.statusText}`);
			}

			return response;
		})
		.catch((error) => {
			if (error.name === 'AbortError') {
				throw new Error('Response timed out');
			}

			throw new Error(error.message);
		});
};

/**
 * @function
 * @param {string} uri - The API URL.
 */
export async function getData(uri) {
	try {
		const response = await fetchWithTimeout(uri, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
			},
		});
		return await response.json();
	} catch (error) {
		console.error(error);
		return [];
	}
}
